import { ContentDataBlockList } from '@amf/shared/components/content/Content';

interface ListProps {
  block: ContentDataBlockList;
}

export default function List({ block }: ListProps) {
  if (block.data.style === 'ordered') {
    return (
      <ol>
        {block.data.items.map((item, key) => (
          <li key={key} dangerouslySetInnerHTML={{ __html: item }} />
        ))}
      </ol>
    );
  }

  return (
    <ul>
      {block.data.items.map((item, key) => (
        <li key={key} dangerouslySetInnerHTML={{ __html: item }} />
      ))}
    </ul>
  );
}
